import React, {useState, useEffect} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FaTrashAlt,FaPencilAlt, FaSave } from "react-icons/fa";
import { dateInDMY } from '../../Helpers';
import { SERVER_API } from '../../fileWithConstants';
import { useAuth } from '../../context/auth';
import {Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import PoEntryRow from './PoEntryRow'
import "react-datepicker/dist/react-datepicker.css";
const InwardPo = () => {
    const [thanFormData, setThanFormData] = useState({});
    const[poIds, setPoIds] = useSearchParams();
    const [auth, setAuth] = useAuth();
    const [userId, setUserId] = useState(auth.user.id);
    const [podata, setPodata]=useState([]);
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [subtotal, setSubtotal] = useState(0); 
    const [totalAmount, setTotalAmount] = useState(0); 
    const [invoiceAmount, setInvoiceAmount] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [invoiceDate, setInvoiceDate] = useState("");
    const navigate = useNavigate();
    const getPodataByIds = async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/supplier/get-multiple-po-data?po-ids=${poIds}`);
            if(data?.success && data?.podata.length>0){
                /* console.log(data) */
                setPodata(data?.podata);
            }else{
              toast.error('Some thing went wrong while getting PO data.')
            }
        } catch (error) {
            console.log(error)
        }
    }

useEffect(()=>{
    getPodataByIds();
},[])


const handleSubmit = async(e)=>{
    e.preventDefault();
    const form = e.currentTarget;
    if(form.checkValidity()===false){
        e.stopPropagation();
    }
    setValidated(true);
if(form.checkValidity()===true) {
    try {
        const formData = new FormData();
        formData.append("invoice_number", invoiceNumber);    
        formData.append("invoice_date", invoiceDate);    
        formData.append("invoice_amount", invoiceAmount);
        formData.append("inw_by", userId);    
        formData.append("podata", JSON.stringify(podata));
        formData.append("thanFormData", JSON.stringify(thanFormData));

         //console.log('--Formdata==podata==',formData); return false; 

        const {data} = await axios.post(`${SERVER_API}/api/v1/supplier/add-po-inw-data`,formData,{
            headers:{'Content-Type': 'application/json'}
          }); 

       // console.log('return from server==>>>',data); return false;

        if(data?.success){
            toast.success(data.message);
            navigate('/dashboard/po-inward-list')
        }

        } catch (error) {
            console.log(error)
        } finally {
            setSubmitting(false);
        }
    }
}

const cancelHandle = ()=>{
    navigate('/dashboard/po-list');
  }

  const deleteTableRows = (index, than_id)=>{
    const rows = [...podata];
    rows.splice(index, 1);
    setPodata(rows);

    setThanFormData(prev => {
        const updated = { ...prev };
        delete updated[than_id];
        return updated;
    });
    
}

const handleChange = (index, evnt)=>{
    /* console.log(index,'rtyrty')
    console.log(evnt.target,'====tt') */
    const { name, value } = evnt.target;
    const rowsInput = [...podata];
  
    if(evnt.target.name=='inw_qty' || evnt.target.name=='inw_price' || evnt.target.name=='inw_discount'){
        rowsInput[index][name] = Number(value);
    }else{
        rowsInput[index][name] = value;
    }

    let amount_total = rowsInput[index]['inw_qty']*rowsInput[index]['inw_price'];
    let discount = rowsInput[index]['inw_discount'];
    let discount_amount = ((amount_total*discount)/100);
    rowsInput[index]['inw_amount'] = (amount_total-discount_amount);
    
    if(rowsInput.length>0){
       let price_arr = rowsInput.map((el,index)=>{
        if(el.inw_amount===undefined){
            return 0;
        }else{
            return el.inw_amount
        }
       }); 
       let sum = price_arr.reduce((accumulator, currentvalue)=>{
          return accumulator+Number(currentvalue);
       },0)
      
      setSubtotal(sum);
      setTotalAmount(sum);
    }
    //console.log(rowsInput)
    setPodata(rowsInput)
  }

  return (
    <Layout title={'Po Inward Page'}>
    <div className='container'>
    <Form noValidate validated={validated} onSubmit={handleSubmit} className='form-section'>
        <div className='row justify-content-center'>
            <div className='col-md-3'>
                <h1 className='page-title text-center'>Stock-In</h1> 
            </div>
            <div className='col-md-2 mb-2'>
            Invoice Number: <input type='text' name='invoice_no' value={invoiceNumber} onChange={(e)=>setInvoiceNumber(e.target.value)} required className='form-control' placeholder='Invoice Number'/>
            </div>

            <div className='col-md-2 mb-2'>
            Invoice Date:  
            <DatePicker
            required
            name='invoice_date'
            className='form-control'
            dateFormat="dd-MM-yyyy"
            selected={invoiceDate}
            onChange={(date) => setInvoiceDate(date)}
            selectsStart
            startDate={invoiceDate}
            placeholder='Invoice Date'
            />
            </div>

            <div className='col-md-2 mb-2'>
            Invoice Amount: <input type='text' name='invoice_amount' value={invoiceAmount} onChange={(e)=>setInvoiceAmount(e.target.value)} required className='form-control' placeholder='Invoice Amount'/>
            </div>
        <div className='col-md-12'>
        
            <div className='table-box'>
            <table className="table table-responsive table-hover">
                <thead>
                <tr className='align-item'>
                    <th scope="col">#</th>
                    <th scope="col" className='text-center'>PO No.</th>
                    <th scope="col" className='text-center'>Supplier</th>
                    <th scope="col" className='text-center'>Fabric</th>
                    <th scope="col" className='text-center'>Fabric(Supplier)</th>
                    <th scope="col" className='text-center'>QTY</th>
                    <th scope="col" className='text-center'>Price</th>
                    <th scope="col" className='text-center'>Order Dt.</th>
                    <th scope="col" className='text-center'>Del. Dt.</th>
                    <th className="text-center">Action</th>
                </tr>
                </thead>
                
                    {podata?.map((po, index)=>(
                        <PoEntryRow
                        key={index}
                        po={po}
                        index={index}
                        handleChange={handleChange}
                        deleteRow={deleteTableRows}
                        thanFormData={thanFormData}
                        setThanFormData={setThanFormData}
                        />
                    ))}
                
            </table>
            <div className='row'>
                        <p><b>Invoice Amount:</b> {invoiceAmount}</p> 
                        <p><b>Total:</b> {totalAmount}</p>
            </div>
            <div className=''>
                <div className='float-end col-2'> 
                <button type="button" onClick={cancelHandle} className="btn btn-warning form-control">Cancel</button>
                </div> 
                <div className='float-end col-2'> 
                <button type="submit" className="btn btn-dark form-control"><FaSave/> Stock-In</button>
                </div>
            </div>

            </div>

           
        </div>
        </div>
        </Form>
    </div>

    </Layout>
  )
}

export default InwardPo
